// extracted by mini-css-extract-plugin
module.exports = {"contentProfile":"profile_contentProfile__3bx6a","editFlex":"profile_editFlex__5vI50","dataProfile":"profile_dataProfile__2C8db","buttonChoice":"profile_buttonChoice__1IX5P"};